export const groupDataByMonthAndGetAvg = (data) => {
  const groupedByMonth = data.reduce((acc, item: any) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [day, month, year] = item.date.split('-');
    const monthYear = `${month}-${year}`;

    if (!acc[monthYear]) {
      acc[monthYear] = { number: 0, count: 0 };
    }

    acc[monthYear].number += item.number;
    acc[monthYear].count += 1;
    return acc;
  }, {});

  return Object.keys(groupedByMonth).map((key) => ({
    date: key,
    number: groupedByMonth[key].number / groupedByMonth[key].count,
  }));
};
